import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Catalog from "@/pages/Catalog";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Videos from "@/pages/Videos";
import Gallery from "@/pages/Gallery";
import Lacak from "@/pages/Lacak";
import Login from "@/pages/Login";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Orders from "@/pages/Orders";
import Account from "@/pages/Account";
import Dashboard from "@/pages/admin/Dashboard";
import OrdersAdmin from "@/pages/admin/OrdersAdmin";
import Products from "@/pages/admin/Products";
import Stock from "@/pages/admin/Stock";
import Finance from "@/pages/admin/Finance";
import Invoices from "@/pages/admin/Invoices";
import InvoiceDetail from "@/pages/admin/InvoiceDetail";
import Crm from "@/pages/admin/Crm";
import Vouchers from "@/pages/admin/Vouchers";
import SuratJalan from "@/pages/admin/SuratJalan";
import TandaTerima from "@/pages/admin/TandaTerima";
import Website from "@/pages/admin/Website";
import BlogsAdmin from "@/pages/admin/BlogsAdmin";
import VideosAdmin from "@/pages/admin/VideosAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import Accounting from "@/pages/admin/Accounting";
import Reports from "@/pages/admin/Reports";
import Content from "@/pages/admin/Content";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tentang" element={<About />} />
              <Route path="/produk" element={<Catalog />} />
              <Route path="/kontak" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/video" element={<Videos />} />
              <Route path="/galeri" element={<Gallery />} />
              <Route path="/lacak" element={<Lacak />} />
              <Route path="/masuk" element={<Login />} />
              <Route path="/toko" element={<Shop />} />
              <Route path="/toko/:id" element={<ProductDetail />} />
              <Route path="/keranjang" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/pesanan" element={<Orders />} />
              <Route path="/akun" element={<Account />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="pesanan" element={<OrdersAdmin />} />
              <Route path="produk" element={<Products />} />
              <Route path="stok" element={<Stock />} />
              <Route path="keuangan" element={<Finance />} />
              <Route path="invoice" element={<Invoices />} />
              <Route path="invoice/:id" element={<InvoiceDetail />} />
              <Route path="crm" element={<Crm />} />
              <Route path="voucher" element={<Vouchers />} />
              <Route path="surat-jalan" element={<SuratJalan />} />
              <Route path="tanda-terima" element={<TandaTerima />} />
              <Route path="website" element={<Website />} />
              <Route path="blog" element={<BlogsAdmin />} />
              <Route path="video" element={<VideosAdmin />} />
              <Route path="galeri" element={<GalleryAdmin />} />
              <Route path="akunting" element={<Accounting />} />
              <Route path="laporan" element={<Reports />} />
              <Route path="konten" element={<Content />} />
              <Route path="pengaturan" element={<Settings />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
